import {NotificationTypes} from '@dynamika-shared/types/subscription';
import { RESTClient } from './client';
import { API_URL } from './apiDictionary';
import {
  NotificationDeliveryStatus,
  NotificationHistoryResponse,
} from '@restore/clinicalTrialNotificationHistory/clinicalTrialNotificationHistory.types';

export type NotificationCountsResponse = {
  notificationType: NotificationTypes;
  count: number;
}[];

export const fetchNotificationCounts = async (clinicalTrialId: string): Promise<NotificationCountsResponse> => {
  const response = await RESTClient.get<NotificationCountsResponse>(API_URL.notificationCounts, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
  return response.data;
};

export type FetchNotificationHistoryParams = {
  page?: number;
  size?: number;
  sort?: string;
  notificationType?: NotificationTypes;
  status?: NotificationDeliveryStatus;
  recipientName?: string;
  recipientEmail?: string;
  dispatchedFrom?: string;
  dispatchedTo?: string;
};

export const fetchNotificationHistory = async (
  clinicalTrialId: string,
  {
    page = 1,
    size = 10,
    sort,
    notificationType,
    status,
    recipientName,
    recipientEmail,
    dispatchedFrom,
    dispatchedTo,
  }: FetchNotificationHistoryParams = {}
): Promise<NotificationHistoryResponse> => {
  const response = await RESTClient.get<NotificationHistoryResponse>(
    API_URL.pmNotifications,
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
      params: {
        page: page - 1,
        size,
        sort,
        notificationType,
        status,
        recipientName,
        recipientEmail,
        dispatchedFrom,
        dispatchedTo,
      },
    }
  );
  return response.data;
};
